import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import ProjectsPage from './pages/ProjectsPage';
import Contact from './pages/Contact';
import ServicesOverview from './pages/ServicesOverview';
import ServiceDetail from './pages/ServiceDetail';
import ProjectDetail from './pages/ProjectDetail';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <>
      {/* Scroll restoration on route change */}
      <ScrollToTop />

      <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900 antialiased selection:bg-brand-orange/20 selection:text-brand-orange">
        {/* Navigation */}
        <Navbar />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser" element={<ServicesOverview />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/projekter" element={<ProjectsPage />} />
            <Route path="/projekter/:slug" element={<ProjectDetail />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            {/* Fallback to 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
